import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface DepartamentoState {
    status: string;
    error: string;
    departamentoList: any[],
    departamentoListActive: any[],
    departamento: {
        idDepartamento: number | null;
        nombre: string | null;
    }

}

const initialState: DepartamentoState = {
    status: 'idle',
    error: '',
    departamentoList: [],
    departamentoListActive: [],
    departamento: {
        idDepartamento: null,
        nombre: null
    }
}

export const fetchDepartamento = createAsyncThunk('fetchDepartamento', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 39;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchDepartamentoActive = createAsyncThunk('fetchDepartamentoActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 40;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const departamentoSlice = createSlice({
    name: 'departamento',
    initialState,
    reducers: {
        setDepartamentoList: (state, action) => {
            state.departamentoList = action.payload;
        },
        setDepartamentoListActive: (state, action) => {
            state.departamentoListActive = action.payload;
        },
        setDepartamento: (state, action) => {
            state.departamento = !action.payload ? initialState.departamento : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchDepartamento.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDepartamento.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.departamentoList = data ? data : [];

            })
            .addCase(fetchDepartamento.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchDepartamentoActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDepartamentoActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.departamentoListActive = data ? data : [];

            })
            .addCase(fetchDepartamentoActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectDepartamentoList = (state: RootState) => state.departamento.departamentoList;
export const selectDepartamentoListActive = (state: RootState) => state.departamento.departamentoListActive;
export const selectDepartamento = (state: RootState) => state.departamento.departamento;

export const { setDepartamentoList, setDepartamentoListActive, setDepartamento } = departamentoSlice.actions;

export default departamentoSlice.reducer;



